// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.siwTargetPage {
    width: 450px;
}

    .siwTargetPage > span {
        font-size: 15px;
        color: var(--integration-text-color);
        margin-bottom: 5px;
    }

    .siwDataSourceCB, .siwTargetTableTB {
        margin-bottom: 20px;
    }

.siwTargetPage > span.siwTargetError {
    color: red;
    font-size: 12px;
    margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/app/integration/smartintegration/smartintegrationwizard/siw.target.page.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;IAEI;QACI,eAAe;QACf,oCAAoC;QACpC,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;AAEJ;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".siwTargetPage {\n    width: 450px;\n}\n\n    .siwTargetPage > span {\n        font-size: 15px;\n        color: var(--integration-text-color);\n        margin-bottom: 5px;\n    }\n\n    .siwDataSourceCB, .siwTargetTableTB {\n        margin-bottom: 20px;\n    }\n\n.siwTargetPage > span.siwTargetError {\n    color: red;\n    font-size: 12px;\n    margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
